export const areaOptions= [
  { value: "DEE", label: "Elbe Saale" },
  { value: "DEH", label: "Hallertau" },
  { value: "DES", label: "Spalt" },
  { value: "DET", label: "Tettnang" },
];
